<template>
  <div class="uni-home">
    <!-- 用户信息 -->
    <div class="item-box user-info">
      <div class="student-info">
        <div class="head-img-box">
          <img
            v-if="studentInfo.thumb"
            :src="studentInfo.thumb"
            alt="暂无头像"
            class="img"
          />
          <img
            v-else
            src="@/assets/images/headEmpty.png"
            alt="暂无头像"
            class="img"
          />
        </div>

        <div class="student-content">
          <p class="name">{{ studentInfo.title | isEmpty }}，欢迎您！</p>
          <ul class="info-list mat10">
            <li class="item">
              <span class="tit">姓<em class="mal28"></em>名： </span>
              <span class="con">{{studentInfo.title}}</span>
            </li>
            <li class="item" v-if="_ENTRANCETYPE === 'adult'">
              <span class="tit">考生号： </span>
              <span class="con">{{studentInfo.candidate_number | isEmpty}}</span>
            </li>
            <li class="item" v-else>
              <span class="tit">准考证号： </span>
              <span class="con">{{studentInfo.exam_number | isEmpty}}</span>
            </li>
            <li class="item">
              <span class="tit">身份证号：</span>
              <span class="con">{{studentInfo.identity | setCard | isEmpty}}</span>
            </li>
            <li class="item">
              <span class="tit">报考类别：</span>
              <span class="con">{{studentInfo.education | isEmpty}}</span>
            </li>
            <li class="item">
              <span class="tit">层<em class="mal28"></em>次：</span>
              <span class="con">{{studentInfo.profession_level | isEmpty}}</span>
            </li>
            <li class="item">
              <span class="tit">专<em class="mal28"></em>业：</span>
              <span class="con">{{studentInfo.profession_title | isEmpty }}</span>
            </li>

          </ul>
          <div>
            <span to class="oringe-link mat10" @click="jump(_ENTRANCETYPE == 'adult' ? 'informationAE' : 'informationST')"
              >查看更多</span
            >
          </div>
        </div>
      </div>

      <div class="teacher-info">
        <div class="teacher-head">
          <el-image
            style="width: 80px; height: 80px; border-radius: 50%"
            :src="studentInfo.teacher_thumb"
            fit="cover"
          >
            <img
              style="width: 100%"
              slot="error"
              src="@/assets/images/headEmpty.png"
              alt="暂无头像"
            />
          </el-image>
        </div>
        <div class="teacher-content">
          <p class="tit">
            <span>
              班主任信息
              <i class="icon icon1"></i>
            </span>
<!--            <i
              @click="jump('studentMessageCenter')"
              class="iconfont iconxinfeng primary f25"
              style="cursor: pointer"
            ></i>-->
          </p>
          <p class="name">{{ studentInfo.teacher_title | isEmpty }}</p>
          <p class="phone">
            <i class="icon3"></i>
            联系电话：{{ studentInfo.teacher_mobile | isEmpty }}
          </p>
        </div>
      </div>
    </div>

    <!-- 课程信息 -->
    <el-row :gutter="15">
      <el-col :span="12">
        <div class="item-box">
          <div class="course-content">
            <div>
              <p class="title">已完成学时（40分钟=1学时）</p>
              <img
                class="course-content-icon"
                src="@/assets/images/complete1.png"
                alt=""
              />
              <p class="num">{{ majorProgress.learn_duration }}</p>
            </div>
            <p>
              <ComponentProgress
                :percentage="
                  percent(
                    majorProgress.learn_duration,
                    majorProgress.sum_duration
                  ) + '%'
                "
              />
            </p>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="item-box">
          <div class="course-content">
            <div>
              <p class="title">已完成课程（门）</p>
              <img
                class="course-content-icon"
                src="@/assets/images/complete.png"
                alt=""
              />
              <p class="num">{{ majorProgress.complete_course }}</p>
            </div>
            <p>
              <ComponentProgress
                :percentage="
                  percent(
                    majorProgress.complete_course,
                    majorProgress.count_course
                  ) + '%'
                "
              />
            </p>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 学习情况 -->
    <el-row type="flex" :gutter="15">
      <el-col :span="8" style="overflow: hidden">
        <div class="item-box2 zn-box" style="height: 100%">
          <em class="smartTitle"></em>
          <p class="uni-line-title">
            <span class="line"></span>
            <span class="span">海量题库，覆盖所有科目</span>
          </p>
          <em class="smartImg"></em>
          <div class="zn-btn" @click="isRouter()">开启智能练习</div>
        </div>
      </el-col>
      <el-col :span="16" style="display: flex; flex-direction: column">
        <!-- 最近学习 -->
        <div class="item-box2 study-content">
          <p class="bold-title">最近学习</p>
          <div class="content-list">
            <div
              class="content"
              v-for="item in latestStudy"
              :key="item.videoid"
            >
              <p class="date">
                <i class="icon el-icon-time mar6"></i>
                <span>{{ item.created_at }}</span>
              </p>
              <div class="con">
                <!-- <span>学习至</span> -->
                <!-- <span class="name"
                  >{{ item.specialtyName }}{{ item.lessonsName }}</span
                > -->
                <span class="name">{{ item.title }}</span>
                <div class="total">
                  <span>已学</span>
                  <span class="primary">{{ item | persent }}%</span>
                  <span>用时</span>
                  <span class="primary">{{
                    item.long_node | formatSeconds
                  }}</span>
                </div>
                <span class="status">{{
                  item.learn_status == 1 ? "已完成" : ""
                }}</span>
                <span
                  class="uni-link-btn"
                  @click="
                    jump('studyNotes', {
                      course_id: item.course_id,
                      lession_id: item.section_id,
                    })
                  "
                >
                  <i class="el-icon-video-play"></i
                  >{{ item.learn_status == 1 ? "重新学习" : "继续学习" }}
                </span>
              </div>
            </div>
            <ComponentEmpty
              v-if="latestStudy.length == 0"
              style="padding: 0"
              imgClass="img-size"
              title="暂无最近的学习"
              tips=""
            />
          </div>
        </div>
        <!-- 最近练习 -->
        <div class="item-box2 study-content">
          <p class="bold-title">最近练习</p>
          <div class="content-list">
            <div class="content" v-for="item in latestPractice" :key="item.id">
              <p class="date">
                <i class="icon el-icon-time mar6"></i>
                <span>{{ item.created_at }}</span>
              </p>
              <div class="con">
                <div class="name">
                  <span class="uni-mark">[{{item.type_title}}]</span>
                  {{ item.title }}
                </div>
                <!-- <span>单项选择</span> -->
                <div class="total">
                  <i class="primary">{{ item.subject_total || 0 }}</i>
                  题 / 对
                  <i class="primary">{{ item.correct_number || 0 }}</i>
                  / 错
                  <i class="primary">{{ item.error_number || 0 }}</i>
                </div>
                <span
                  class="uni-link-btn"
                  @click="isJump(item)"
                >
                  <i class="el-icon-video-play"></i>继续练习
                </span>
              </div>
            </div>
            <ComponentEmpty
              v-if="latestPractice.length == 0"
              style="padding: 0"
              imgClass="img-size"
              title="暂无最近的练习"
              tips=""
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ComponentProgress from "@/components/componentProgress";
import {
  getUserInfo,
  getStudyRate,
  getNewExams,
  getNewStudy,
  getNewPractice,
} from "@/api/basic";
import { mapState } from "vuex";
export default {
  name: "Home",
  components: {
    ComponentProgress,
  },
  data() {
    return {
      themed: "",
      studentInfo: {},
      majorProgress: {
        learn_duration: 0,
        sum_duration: 0,
        count_course: 0,
        complete_course: 0,
      },
      data: [1, 2],
      latestStudy: [],
      latestExam: [],
      latestPractice: [],
    };
  },
  computed: {
    ...mapState("common", {
      studentMajor: (state) => state.studentMajor,
    }),
    ...mapState("permission", {
      _ENTRANCETYPE: (state) => state._ENTRANCETYPE,  //成教/自考
    }),
  },
  watch: {
    studentMajor(val) {
      if (val) {
        this.getStudentInfo();
        this.getStudentMajorProgress();
        this.getStudy();
        this.getPractice();
        this.getExam();
      }
    },
  },
  filters: {
    setCard(val) {
      if (val) {
        return val.substring(0, 3) + "****" + val.substring(14, 18);
      }
    },
    persent(item) {
      if (item.video_duration) {
        return parseInt((item.long_node / item.video_duration) * 100);
      }
      return 0;
    },
  },
  mounted() {
    if (this.studentMajor && this.studentMajor.profession_id) {
      this.getStudentInfo();
      this.getStudentMajorProgress();
      this.getStudy();
      this.getPractice();
      this.getExam();
    }
    this.$store.commit("common/changeMenuMutation", { name: "" });
  },
  methods: {
    isJump(item) {
      if(item.test_id>0) {
        this.$router.push({
          name: "realTestStart",
          query: {
            type: 3,
            test_id: item.test_id,
            course_id:item.course_id
          }
        });
        return;
      }
      if(item.make_type === 2){
        this.$router.push({
          name: "startPractice",
          query: {
            section_id: item.section_id,
            course_id:item.course_id
          }
        });
        return;
      }
      if(item.make_type === 1){
        this.$router.push({
          name: "homeWork",
          query: {
            section_id: item.section_id,
            course_id:item.course_id
          }
        });
        return;
      }
      this.$store.commit("common/changeMenuMutation", { name: "智能练习" });
      this.$router.push({
        name: "allTest",
      });
    },
    isRouter() {
      this.$store.commit("common/changeMenuMutation", { name: "智能练习" });
      this.$router.push({
        name: "allTest",
      });
    },
    // 获取学生信息请求
    async getStudentInfo() {
      const { result } = await getUserInfo();
      if (result) {
        this.studentInfo = result;
      }
    },
    //已完成课时、课程
    async getStudentMajorProgress() {
      const { result } = await getStudyRate();
      if (result) {
        this.majorProgress = result;
      }
    },
    //最近学习
    async getStudy() {
      const { result } = await getNewStudy();
      if (result) {
        this.latestStudy = result;
      }
    },
    //最近练习
    async getPractice() {
      const { result } = await getNewPractice();
      if (result) {
        this.latestPractice = result;
      }
    },
    //最近考试
    async getExam() {
      /*const { result } = await getNewExams();
      if (result) {
        this.latestExam = result.slice(0, 4);
        //console.log(this.latestExam)
      }*/
    },
    percent(cur, total) {
      let percent = 0;
      if (total != 0) {
        percent = parseInt((cur / total) * 100);
      }
      return percent;
    },
    jump(name, query) {
      this.$router.push({
        name: name,
        query: query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.uni-home {
  padding: 5px 20px 0;

  /deep/ .img-size {
    width: 120px;
  }
  /deep/ .img-size-small {
    width: 60px;
  }

  .item-box {
    display: flex;
    background: #fff;
    margin-top: 15px;
  }

  .item-box2 {
    background: #fff;
    margin-top: 15px;
    padding: 25px;
  }

  .uni-mark {
    @include fontColor("primary");
  }

  .bold-title {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }

  .user-info {
    // height: 190px;
    overflow: hidden;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .student-info {
      flex: 1;
      display: flex;
      align-items: center;

      .head-img-box {
        width: 110px;
        height: 150px;
        border: 1px solid $gray;
        overflow: hidden;

        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .student-content {
        // height: 110px;
        margin-left: 20px;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;

        .name {
          font-size: 18px;
          font-weight: bold;
          @include fontColor("primary");
        }

        .info-list {
          display: flex;
          flex-wrap: wrap;
          width: 100%;

          .item {
            width: 50%;
            margin-top: 10px;
            padding-right: 20px;
            display: flex;
            color: $textGray;

            .tit {
              text-align: justify;
            }
            .con {
              flex: 1;
              @extend %ellipse;
            }
          }
        }

        .link {
          color: $oringe;
          margin-top: 10px;
          display: inline-block;
        }
      }
    }

    .teacher-info {
      flex: 0.6;
      display: flex;
      align-items: center;
      background: $grayBg;
      min-height: 110px;
      margin-left: 20px;
      padding: 20px;

      .teacher-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 20px;
        height: 80px;

        .tit {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 30px;
          border-bottom: 1px solid $gray;
        }

        .icon {
          display: inline-block;
          width: 20px;
          height: 14px;
          vertical-align: middle;

          &.icon1 {
            background: url("~@/assets/images/08.png") center 100% no-repeat;
          }
        }

        .icon3 {
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url("~@/assets/images/10.png") center 100% no-repeat;
          vertical-align: middle;
        }

        .name {
          color: $textGray;
        }

        .phone {
          color: #666666;
        }
      }
    }
  }

  .course-content {
    flex: 1;
    height: 190px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .course-content-icon {
      position: absolute;
      right: 0;
      top: 0;
    }
    &.box3 {
      justify-content: start;
    }

    .title {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: $textGray;
    }

    .num {
      font-size: 50px;
      line-height: 50px;
    }

    .article-list {
      flex: 1 1 auto;
      margin-top: 20px;
      .link {
        display: flex;
        justify-content: space-between;
        color: $textColor;
        line-height: 25px;
        cursor: pointer;

        &:hover {
          @include fontColor("primary");
        }
        .tit {
          flex: 1;
          @extend %ellipse;
        }

        .date {
          color: $textGray;
        }
      }
    }
  }

  .zn-box {
    text-align: center;
    .uni-line-title {
      font-size: 16px;
      color: #666;
      position: relative;
      width: 80%;
      text-align: center;
      margin: 0 auto 28px;

      .line {
        height: 12px;
        border-bottom: 1px solid #666;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
      .span {
        position: relative;
        display: inline-block;
        background: #fff;
        padding: 0 10px;
      }
    }
    .smartTitle {
      width: 93px;
      height: 23px;
      @include themeIcon("smartTitle");
      background-size: 100% auto;
      display: inline-block;
      margin: 10px 0 24px;
    }
    .smartImg {
      width: 214px;
      height: 143px;
      @include themeIcon("smartIcon");
      background-size: 100% auto;
      display: inline-block;
    }
    .zn-btn {
      width: 244px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      @include bgColor("zn-btn-start");
      @include linearGradientEdg("zn-btn-start", "zn-btn-end", 24deg);
      border-radius: 24px;
      font-size: 18px;
      color: #fff;
      margin: 35px auto 0;
      cursor: pointer;
    }
  }

  .study-content {
    // height: 233px;
    // flex: 1;
    // overflow: hidden;
    .content-list {
      .content {
        margin-top: 20px;
      }
      .date {
        color: $textGray;

        .icon {
          font-size: 18px;
          vertical-align: baseline;
          @include fontColor("primary");
        }
      }

      .con {
        display: flex;
        margin-top: 10px;
        margin-left: 20px;
        justify-content: space-between;
        align-items: center;

        .name {
          flex: 2;
          max-width: 350px;
          @extend %ellipse;
        }
        .status {
          // flex: 1;
          min-width: 80px;
          padding: 0 10px;
          @include fontColor("primary");
        }
        .total {
          flex: 1;
          min-width: 300px;
          margin: 0 10px;

          span {
            margin-left: 10px;
          }
        }
      }
    }

    .uni-link-btn {
      @include uni-link-btn;
    }
  }

  .video-content {
    background: #fff;
    height: 485px;
    margin-top: 20px;
    padding: 20px;

    .video-lists {
      display: flex;
      flex-wrap: wrap;
      .item {
        cursor: pointer;
        margin-top: 20px;
        width: 50%;

        .img {
          width: 224px;
          height: 126px;
        }

        &:hover {
          .tit {
            @include fontColor("primary");
          }
        }
      }
    }
  }
}
</style>
